import axios from 'axios'
import type { IPublicClientApplication, AccountInfo } from '@azure/msal-browser'
import { acquireApiToken } from './authTokenUtils'
import { getRuntimeConfig } from './configUtils'
import { joinUrl } from './urlUtils'

export async function apiRequest<T>(
  instance: IPublicClientApplication,
  account: AccountInfo,
  method: 'get' | 'post',
  path: string,
  timeout = 15000,
): Promise<T> {
  const accessToken = await acquireApiToken(instance, account)
  const apiUrl = getRuntimeConfig('REACT_APP_API_URL')
  if (!apiUrl) throw new Error('API URL is not configured')

  const res = await axios.request<T>({
    method,
    url: joinUrl(apiUrl, path),
    headers: { Authorization: `Bearer ${accessToken}` },
    timeout,
  })
  return res.data
}
